<template>
  <div class="feed-container">
    <div class="inner-wrapper">
      <p class="header">{{ header }}</p>
      <div
        ref="wrapper"
        class="feed-wrapper"
        :class="{ 'feed-wrapper--animate': animate }"
      >
        <div ref="content" class="feeds">
          <p class="feed" v-html="feeds" />
          <p v-if="animate" class="feed" v-html="feeds" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, toRefs } from 'vue'

const props = defineProps<{ type: 'alerts' | 'notices'; feed: string[] }>()

const animate = ref(false)
const wrapper = ref<HTMLElement | null>(null)
const content = ref<HTMLElement | null>(null)

const { type, feed } = toRefs(props)

const header = computed(() =>
  type.value === 'alerts' ? 'Alert :' : 'Notice :'
)

const duration = computed(() => feed.value.length)

const feeds = computed(() => feed.value.join('<span></span>'))

onMounted(() => {
  if (wrapper.value && content.value) {
    animate.value = content.value.offsetWidth > wrapper.value.offsetWidth
  }
})

const color = computed(() => (type.value === 'alerts' ? '#ef9367' : '#5c9eec'))
</script>
<style lang="scss" scoped>
.feed-container {
  position: relative;
  width: 100%;
  height: vh(182px);
}

.inner-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: vh(3px);
  border-top: vh(2px) solid v-bind(color);
}

.header {
  position: relative;
  font-family: $font-paragraph;
  font-size: vh(83px);
  font-weight: 500;
  line-height: vh(100px);
  color: v-bind(color);
  white-space: nowrap;

  &::after {
    position: absolute;
    top: vh(2px);
    right: vw(-35px);
    z-index: 2;
    display: block;
    width: vw(40px);
    height: 100%;
    content: '';
    background: linear-gradient(
      90deg,
      #20201f 0%,
      #20201f 50%,
      transparent 100%
    );
  }
}

.feed-wrapper {
  position: relative;
  width: 100%;
  height: vh(135px);
  overflow: hidden;
}

.feeds {
  position: absolute;
  display: flex;

  .feed-wrapper--animate & {
    animation: marquee calc(v-bind(duration) * 9s) linear infinite;
  }
}

.feed {
  display: flex;
  align-items: center;
  padding: 0 vw(25px);
  font-size: vh(95px);
  color: v-bind(color);
  white-space: nowrap;
  transform: translate3d(0, 0, 0);

  .feed-wrapper--animate & {
    padding: 0 vw(60px);

    &::before {
      position: absolute;
      top: 50%;
      left: vw(-10px);
      display: block;
      width: vw(20px);
      height: vw(20px);
      content: '';
      background-color: v-bind(color);
      border-radius: 50%;
      transform: translateY(-50%);
    }
  }

  :deep(span) {
    display: inline-block;
    width: vw(20px);
    height: vw(20px);
    margin: 0 vw(60px);
    background-color: v-bind(color);
    border-radius: 50%;
  }
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }

  100% {
    transform: translateX(-50%);
  }
}
</style>
